var _circle, _rect, _mask, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEmptyChat = function SvgEmptyChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 12.75,
    fill: "#373737",
    stroke: "#373737",
    strokeWidth: 1.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12.5,
    height: 8.5,
    x: 7.75,
    y: 11.75,
    stroke: "#00B9F7",
    strokeWidth: 1.5,
    rx: 0.75
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "emptyChat_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 5,
    x: 9.5,
    y: 13.5,
    rx: 0.5
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 5,
    x: 9.5,
    y: 13.5,
    stroke: "#00B9F7",
    strokeWidth: 2,
    mask: "url(#emptyChat_svg__a)",
    rx: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#00B9F7",
    strokeWidth: 1.5,
    d: "M9.75 10a4.25 4.25 0 0 1 8.5 0v1.75h-8.5z"
  })));
};
export default SvgEmptyChat;